<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisor"
          :receitas="enableReceita"
          :url="link"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'100'"
                    :text="'Faturamento'"
                    :texto-information="textoFaturamento"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  id="componenteDevImpropria"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <v-card
                    id="cardDashbord"
                    class="mx-auto"
                    outlined
                  >
                    <div class="card-header-dashbord">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="10"
                          md="10"
                          lg="10"
                          class="d-flex flex-wrap"
                        >
                          Devolução Imprópria
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          md="2"
                          lg="2"
                          class="d-flex justify-end"
                        >
                          <v-tooltip top>
                            <template
                              v-slot:activator="{ on, attrs }"
                            >
                              <v-icon
                                id="iconInformationDevolucaoComercial2"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('126')"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <div
                              v-if="codigo === '126'"
                              v-html="textoOrientacao"
                            />
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </div>
                    <v-card-actions>
                      <v-row id="componenteDevolucaoImpropria">
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <show-devolucao-impropria id="ChartDevolucaoImpropriaComercial2" />
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'101'"
                    :text="'Meta'"
                    :texto-information="textoMeta"
                    :style-object="styleObjectMeta"
                    :componente-valor="true"
                    :valor="meta"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingMeta"
                    style="margin: 0rem 0 0 0"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <!-- id="componenteMetaAtual" -->
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'102'"
                    :text="'Meta Mensal'"
                    :texto-information="textoMetaMensal"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart2'"
                    :title="titleChartMetaFat"
                    :dados-grafico="chartMetaGrafico"
                    :titulo-id="'titulo2'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingGraficoMeta"
                    style="margin: 0.1rem 0 0 0"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <v-card
                    id="cardDashbord"
                    class="mx-auto"
                    outlined
                  >
                    <div class="card-header-dashbord">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="10"
                          md="10"
                          lg="10"
                          class="d-flex flex-wrap"
                        >
                          Comparativo Fat. x Meta
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          md="2"
                          lg="2"
                          class="d-flex justify-end"
                        >
                          <v-tooltip top>
                            <template
                              v-slot:activator="{ on, attrs }"
                            >
                              <v-icon
                                id="iconInformationFatxMetaComercial2"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('103')"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <div
                              v-if="codigo === '103'"
                              v-html="textoOrientacao"
                            />
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </div>
                    <v-card-actions>
                      <v-row id="componenteDevolucaoImpropria">
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <bar-line-chart
                            id="BarLineComercial2"
                            class="itemBarrasLinhasComercial2"
                          />
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'104'"
                    :text="'Fat. mês anterior'"
                    :texto-information="textoFaturamentoAnterior"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamentoMesAnterior"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingFaturamentoMesAnterior"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'105'"
                    :text="'Mês Anterior'"
                    :texto-information="textoFatxFatAnterior"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart3'"
                    :title="titleChartFatxFatAnterior"
                    :dados-grafico="chartFatxFatAnterior"
                    :titulo-id="'titulo3'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingGraficoCompFatAnterior"
                    style="margin: -0.1rem 0 0 0"
                  />
                </v-col>
                <v-col
                  id="componenteFatMesAnoAnteriorComercial2"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'106'"
                    :text="'Fat. do Mês do Ano Anterior'"
                    :texto-information="textoFaturamentoAnoAnterior"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamentoMesAnoAnterior"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingFaturamentoMesAnoAnterior"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <!-- id="componenteFatMesAnotAnterior" -->
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'107'"
                    :text="'Mês do Ano Anterior'"
                    :texto-information="textoFatxFatAnoAnterior"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart4'"
                    :title="titleChartFatxFatAnoAnterior"
                    :dados-grafico="chartFatxFatAnoAnterior"
                    :titulo-id="'titulo4'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingGraficoCompFatAnoAnterior"
                    style="margin: -0.1rem 0 0 0"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteValorMonetarioComercial2"
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <v-container>
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      E quanto falta para atingirmos?
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip top>
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationComercial2"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('108')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="codigo === '108'"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="6"
                    >
                      <valor-monetario id="valorMonetarioGraficoComercial2" />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="6"
                    >
                      <valor-monetario-diario id="valorMonetarioDiarioGraficoComercial2" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-container>
          </v-col>
          <v-col
            id="componenteTendenciaFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'109'"
                    :text="'Qual a tendência de faturamento?'"
                    :texto-information="textoTendencia"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorTedenciaFaturamento"
                    :padding="dynamicPaddingBloco5"
                    :loading="loadingTendenciaFaturamento"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'110'"
                    :text="'Qual a quantidade de dias úteis no mês?'"
                    :texto-information="textoDiasUteis"
                    :style-object="styleObject"
                    :componente-dias-uteis="true"
                    :dias-uteis="diasUteis"
                    :dias-pecorrido="diasPecorrido"
                    :padding="dynamicPaddingBloco5"
                    :loading="loadingDiasUteis"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
            style="margin: -2rem 0 0 0;"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'111'"
                    :text="'E minha carteira de pedidos?'"
                    :texto-information="textoPedidos"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorPedidos"
                    :padding="dynamicPaddingBloco6"
                    :loading="loadingPedidos"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'112'"
                    :text="'E quanto está minha volumetria?'"
                    :texto-information="textoVolume"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="`${valorVolume} Kg`"
                    :padding="dynamicPaddingBloco6"
                    :loading="loadingVolume"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import Comercial from '../../../../services/comercial'
  import Chart from 'chart.js'

  // REGISTRA O PLUGIN GRAFICO DOUGHNUT APENAS UMA VEZ
  const pluginComercial = {
    id: 'centerText',
    beforeDraw (chart) {
      const centerConfig = chart.config.options.elements?.center
      if (!centerConfig) return

      const ctx = chart.chart.ctx
      const txt = centerConfig.text
      const fontStyle = centerConfig.fontStyle || 'Arial'
      const color = centerConfig.color || '#000'

      const width = chart.chartArea.right - chart.chartArea.left
      const height = chart.chartArea.bottom - chart.chartArea.top

      const fontSize = Math.min(width, height) / 5

      ctx.save()
      ctx.font = `${fontStyle} ${fontSize}px Arial`
      ctx.fillStyle = color
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'

      const centerX =
        (chart.chartArea.left + chart.chartArea.right) / 2
      const centerY =
        (chart.chartArea.top + chart.chartArea.bottom + 130) / 2

      ctx.fillText(txt, centerX, centerY)
      ctx.restore()
    },
  }

  export default {
    name: 'PageComercial',
    emits: ['updateDatas', 'setDados', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      ShowDevolucaoImpropria: () => import('../../graficos/Comercial/DevolucaoImpropria'),
      BarLineChart: () => import('../../graficos/Comercial/BarLineChart'),
      ValorMonetario: () => import('../../graficos/Comercial/ValorMonetario'),
      ValorMonetarioDiario: () => import('../../graficos/Comercial/ValorMonetarioDiario'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      styleObjectCarteiraPedidos: {
        color: '#9d9ac5',
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      supervisores: [],
      receitas: [],
      textoFaturamento: '',
      textoDevolucao: '',
      textoMeta: '',
      textoMetaMensal: '',
      textoFaturamentoMeta: '',
      textoFaturamentoAnterior: '',
      textoFatxFatAnterior: '',
      textoFaturamentoAnoAnterior: '',
      textoFatxFatAnoAnterior: '',
      textoAtigimento: '',
      textoTendencia: '',
      textoDiasUteis: '',
      textoPedidos: '',
      textoVolume: '',
      codigo: 0,
      orientacao: [],
      codigoIds: ['100', '101', '102', '103', '104', '105', '106', '107', '108', '109', '110', '111', '112', '126'],
      loading: false,
      error: null,
      permissaoGestaoComercial: '',
      activeHover: false,
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisor: true,
      enableReceita: true,
      link: window.location.href,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      devolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      meta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      chartMeta: {},
      titleChartMeta: '',
      legendaGrafico: [
        { cor: '#ed934f', status: 'Meta Diária' },
        { cor: '#4780b8', status: 'Acima da Meta' },
        { cor: '#cadaed', status: 'Abaixo da Meta' },
      ],
      chartBarLinha: {},
      valorFaturamentoMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      titleChartFatxFatAnterior: '',
      chartFatxFatAnterior: {},
      valorFaturamentoMesAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoMesAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      chartFatxFatAnoAnterior: {},
      titleChartFatxFatAnoAnterior: '',
      chartValorMonetario: {},
      chartValorMonetarioDiario: {},
      valorRestante: '',
      valorExibicao: '',
      valorRestante2: '',
      valorExibicao2: '',
      valorTedenciaFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      diasUteis: '0',
      diasPecorrido: '0',
      valorPedidos: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorVolume: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      devolucaoImpropria: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      chartDevolucaoImpropria: {},
      dynamicPaddingBloco1: '',
      dynamicPaddingBloco2: '',
      dynamicPaddingBloco3: '',
      dynamicPaddingBloco4: '',
      dynamicPaddingBloco5: '',
      dynamicPaddingBloco6: '',
      dynamicPaddingFatxMeta: '',
      dynamicPaddingValorMonetario: '',
      dynamicPaddingDevImpropria: '',
      dynamicPaddingMesAntgerior: '',
      loadingFaturamento: false,
      loadingMeta: false,
      loadingFaturamentoMesAnterior: false,
      loadingFaturamentoMesAnoAnterior: false,
      loadingTendenciaFaturamento: false,
      loadingDiasUteis: false,
      loadingPedidos: false,
      loadingVolume: false,
      textoOrientacao: '',
      chartMetaGrafico: {},
      titleChartMetaFat: '',
      loadingGraficoMeta: false,
      loadingGraficoCompFatAnterior: false,
      loadingGraficoCompFatAnoAnterior: false,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)

      Chart.plugins.unregister(pluginComercial)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        Chart.plugins.register(pluginComercial)

        eventEmit.$emit('atualizar_texto', 'Gestão Comercial')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.paginaEnable = true

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 15.7rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 45rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 13rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 21rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 18rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 21rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 42rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 21rem !important'

          this.dynamicPaddingDevImpropria = 'padding-right: 4rem !important'

          this.dynamicPaddingMesAntgerior = 'padding-right: 13rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 10rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 30rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 9rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 8rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 14rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 33rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 14rem !important'

          this.dynamicPaddingDevImpropria = 'padding-right: 10rem !important'

          this.dynamicPaddingMesAntgerior = 'padding-right: 9rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBloco1 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 12rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 12rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 21rem !important'

          this.dynamicPaddingDevImpropria = 'padding-right: 11rem !important'

          this.dynamicPaddingMesAntgerior = 'padding-right: 4rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingBloco1 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 12rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 12rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 21rem !important'

          this.dynamicPaddingDevImpropria = 'padding-right: 11rem !important'

          this.dynamicPaddingMesAntgerior = 'padding-right: 4rem !important'
        } else {
          this.dynamicPaddingBloco1 = 'padding-right: 4rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 28rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 2rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 8rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 4rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 7rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 21rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 7rem !important'

          this.dynamicPaddingDevImpropria = 'padding-right: 4rem !important'

          this.dynamicPaddingMesAntgerior = 'padding-right: 2rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receitas) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisores = supervisores
        this.receitas = receitas

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', primeiroDia)
        localStorage.setItem('dataFinal', dataFinal)

        this.updateDate()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async enableTexto (value) {
        await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value).then(resposta => {
          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao

            this.codigo = value
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.message === 'Permissão para a pagina não encontrada, metodo 8') {
            this.$router.push('/dashboard')
          }
        })
      },

      async updateDate () {
        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.meta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoMesAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoMesAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorTedenciaFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.diasUteis = '0'
        this.diasPecorrido = '0'
        this.valorPedidos = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorVolume = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.loadingFaturamento = true
        this.loadingMeta = true
        this.loadingFaturamentoMesAnterior = true
        this.loadingFaturamentoMesAnoAnterior = true
        this.loadingTendenciaFaturamento = true
        this.loadingDiasUteis = true
        this.loadingPedidos = true
        this.loadingVolume = true
        this.loadingGraficoMeta = true
        this.loadingGraficoCompFatAnterior = true
        this.loadingGraficoCompFatAnoAnterior = true

        if (this.chartMetaGrafico.data) {
          this.chartMetaGrafico.destroy()
        }

        if (this.chartFatxFatAnoAnterior.data) {
          this.chartFatxFatAnoAnterior.destroy()
        }

        if (this.chartFatxFatAnterior.data) {
          this.chartFatxFatAnterior.destroy()
        }

        eventEmit.$emit('update-datas', this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, [], [], [], [])

        await Comercial.showFaturamento(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamento = false })

        await Comercial.showMeta(this.primeiroDia, this.date, this.select, this.supervisores, localStorage.tokencontrato, []).then(resposta => {
          if (resposta.data.status) {
            this.meta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.meta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, 'Não há meta no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingMeta = false })

        await Comercial.showDadosGraficoMetaMensal(this.primeiroDia, this.date, this.select, this.supervisores, [], localStorage.tokencontrato, [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.titleChartMetaFat = resposta.data.faturamentoMensal.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart2').getContext('2d')

            this.chartMetaGrafico = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.faturamentoMensal, resposta.data.valorMeta],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartMetaFat,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.text
            this.title = '0,0' + '%'
            this.showSnackbar('error', 3000, resposta.data.text)
            if (!this.montarGrafico) {
              this.myChart.destroy()
            }
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.text = resposta.data.text
            this.title = '0,0' + '%'
            this.showSnackbar('error', 3000, resposta.data.text)

            if (this.myChart.data) {
              this.myChart.destroy()
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Não há meta no período selecionado') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.error = e.data.text

            this.title = '0,0' + '%'
          }
        }).finally(f => { this.loadingGraficoMeta = false })

        await Comercial.showFaturamentoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoMesAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamentoMesAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamentoMesAnterior = false })

        await Comercial.showDadosGraficoFaturamentoMesAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.titleChartFatxFatAnterior = resposta.data.porcentagemFaturamento.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart3').getContext('2d')

            this.chartFatxFatAnterior = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.porcentagemFaturamento, resposta.data.porcentagemAnterior],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 65,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartFatxFatAnterior,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.titleChartFatxFatAnterior = '0,0 %'

            if (this.chartFatxFatAnterior.data) {
              this.chartFatxFatAnterior.destroy()
            }

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoCompFatAnterior = false })

        await Comercial.showFaturamentoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoMesAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamentoMesAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamentoMesAnoAnterior = false })

        await Comercial.showDadosGraficoFaturamentoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.titleChartFatxFatAnoAnterior = resposta.data.porcentagemFaturamento.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart4').getContext('2d')

            this.chartFatxFatAnoAnterior = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.porcentagemFaturamento, resposta.data.porcentagemAnterior],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 65,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartFatxFatAnoAnterior,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.titleChartFatxFatAnoAnterior = '0,0 %'

            if (this.chartFatxFatAnoAnterior.data) {
              this.chartFatxFatAnoAnterior.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoCompFatAnoAnterior = false })

        await Comercial.showTendenciaFaturamento(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, [], [], [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não hsá tendência pro mês selecionado') {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingTendenciaFaturamento = false })

        await Comercial.showDiasFaturamento(this.primeiroDia, this.date, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.diasUteis = resposta.data.diaUtil.toString()
            this.diasPecorrido = resposta.data.diatrabalhados.toString()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDiasUteis = false })

        await Comercial.showValorMonetarioPedidosAbertos(this.primeiroDia, this.date, this.select, this.receitas, localStorage.tokencontrato, this.supervisores, [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorPedidos = resposta.data.pedidosAberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingPedidos = false })

        await Comercial.showValorTotalVolume(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, [], [], [], [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorVolume = resposta.data.kilosFaturado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingVolume = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    .filterMobile{
      display: block
    }

    .filterWeb{
      display: none
    }

    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    .break {
      flex-basis: 100%;
      height: 0;
    }

    #faturamentoComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -1rem 0 0 -6rem;
    }

    #componenteValorFatComercial2 {
      margin: -1rem 0 0 -4rem;
    }

    #iconInformationFaturamentoComercial2 {
      margin: -5.7rem 0 0 19rem !important;
      font-size: 17px;
    }

    #textoDevolucaoImpropriaComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -1rem 0 0 -6rem;
    }

    #iconInformationDevolucaoComercial2 {
      margin: -1.5rem 0 0 1rem !important;
    }

    #ChartDevolucaoImpropriaComercial2 {
      width: 80px;
      height: 50px;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -2rem 0 0 8rem !important;
    }

    #metaComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 0 -9rem !important;
    }

    #componentevlrMetaComercial2 {
      margin: -1rem 0 0 9.8rem;
    }

    #iconInformationMetaComercial2 {
      margin: -1.4rem 0 0 22.1rem !important;
      font-size: 17px;
    }

    #textoMetaMensalComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 0 -9rem !important;
    }

    #iconInformationDesempenhoFatComercial2 {
      margin: -6rem 0 0 12rem !important;
      font-size: 17px;
    }

    #ChartPieComercial2 {
      width: 80px;
      height: 50px;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -3.7rem 0 0 4.5rem !important;
    }

    #BarLineComercial2 {
      height: 110px;
      width: 370px;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -5rem 0 10rem 2rem !important;
    }

    #iconInformationFatxMetaComercial2 {
      margin: -0rem 0 0 0rem !important;
    }

    .containerBarrasLinhas {
      display: flex;
      flex-wrap: wrap;
    }

    .itemBarrasLinhasComercial2 {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    #faturamentoAnteriorComercial2 {
      font-size: 12px;
      margin: 0 5rem 0 0rem !important;
      display: block ruby;
    }

    #componenteVlrFatAnteriorComercial2 {
      margin: -2.5rem 0 0 -0.15rem;
    }

    #iconInformationFatMesAnteriorComercial2 {
      margin: -2.8rem 0 0 13.4rem !important;
      font-size: 17px;
    }

    #linhaChartPie2Comercial2 {
      margin: 0 0 0 -0.5rem;
    }

    #ChartPie2Comercial2 {
      width: 80px;
      height: 50px;
      font-size: 16px;
      align-items: center;
      font-weight: bold;
      margin: -8rem 2rem 0 6.5rem !important;
    }

    #iconInformationDesempenhoMesAnteriorComercial2 {
      margin: 0rem 0 0 12.8rem !important;
      font-size: 17px;
    }

    #textoMesAnteriorComercial2 {
      font-size: 12px;
      margin: 8rem 0 0 -7rem;
    }

    #componenteGraficoPie2Comercial2 {
      margin: 6.8rem 0 0 4.5rem;
    }

    #componenteFatMesAnoAnteriorComercial2 {
      margin: 0 0 0 -0.4rem;
    }

    #componenteVlrFatMesAnoAnteriorComercial2 {
      margin: -32.3rem 0 0 8.4rem;
    }

    #faturamentoMesAnoAnteriorComercial2 {
      font-size: 12px;
    }

    #iconInformationFatMesAnoAnteriorComercial2 {
      margin: -3rem 0 0 13.8rem !important;
      font-size: 17px;
    }

    #componenteDesMesAnoAnteriorComercial2 {
      margin: 2.6rem 0 0 -2.3rem;
    }

    #ChartPie3Comercial2 {
      width: 80px;
      height: 60px;
      font-size: 16px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -1rem 0 0 4rem !important;
    }

    #iconInformationDesMesAnoAnteriorComercial2 {
      margin: -2rem 0 0 0rem !important;
      font-size: 17px;
    }

    #textoMesAnoAnteriorComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -2rem 0 0 -3.1rem !important;
    }

    #btnRefazer {
      font-size: 10px;
      margin-top: 2rem;
      margin-left: -1.4rem;
    }

    #iniciobloco2Comercial2 {
      font-size: 12px;
      display: flex;
      align-items: center;
      margin-left: 1rem;
    }

    #iconInformationComercial2 {
      margin: -3rem 1rem 0 0rem !important;
      font-size: 17px;
    }

    #valorMonetarioComercial2 {
      font-size: 8px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #valorMonetarioGraficoComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #valorMonetarioDiarioGraficoComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    .textoTendenciaFaturametno {
      margin: 11rem 0 0 2rem;
      font-size: 12px;
    }

    .textoDiasFaturametno {
      margin: -2rem 0 0 2rem;
      font-size: 12px;
    }

    #iconInformationDiasUteisComercial2 {
      margin: -7rem 0 0 28.6rem !important;
      font-size: 18px;
    }

    #iconInformationTendenciaComercial2 {
      margin: -3rem 1rem 0 28rem !important;
      font-size: 18px;
    }

    #componenteVlrTendenciaComercial2 {
      margin: -7.6rem 0 0 -2rem;
    }

    #textoCarteiraPedidoComercial2 {
      margin: -15rem 0 0 0.5rem !important;
      font-size: 14px;
    }

    #iconInformationPedidosComercial2 {
      margin: -3rem 1rem 0 0rem !important;
      font-size: 18px;
    }

    #componenteDiasFaturadosComercial2 {
      margin: 0 0 0 2rem !important;
      font-size: 12px !important;
    }

    #componenteCarteiraPedidosComercial2 {
      margin: 10rem 0 0 3rem !important;
    }

    #volumetriaTextoComercial2 {
      margin: -12rem 0 0 0.5rem !important;
      font-size: 14px;
    }

    #iconInformationVolumetriaComercial2 {
      margin: -12rem 1rem 0 0rem !important;
      font-size: 18px;
    }

    #componenteVolumeLeiteComercial2 {
      margin: 10rem 0 0 -1.5rem;
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    .filterMobile{
      display: none
    }

    .filterWeb{
      display: block
    }

    #btnRefazer {
      font-size: 12px;
      display: flex;
      max-width: 15vw;
    }

    .container {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .cell {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
      max-width: 840px;
    }

    .break {
      flex-basis: 100%;
      height: 0;
    }

    #faturamentoComercial2 {
      font-size: 18px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 0 -4rem;
    }

    #iconInformationFaturamentoComercial2 {
      margin: -9.5rem 0 0 19rem;
    }

    #componenteValorFatComercial2 {
      margin: 0 0 0 8rem;
    }

    #textoDevolucaoImpropriaComercial2 {
      margin: 0 0 0 -9rem;
      font-size: 18px;
    }

    #ChartDevolucaoImpropriaComercial2 {
      margin: 0.5rem 0 0 8rem;
    }

    #iconInformationDevolucaoComercial2 {
      margin: -2rem 0 0 0rem;
    }

    #componenteDevImpropria {
      margin: 0rem 0 0 -1rem;
    }

    #metaComercial2 {
      font-size: 18px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 2rem 0 0 -8.3rem
    }

    #iconInformationMetaComercial2 {
      margin: -2rem 0 0 23.2rem;
    }

    #componentevlrMetaComercial2 {
      margin: 0rem 0 0 13.3rem;
    }

    #iconInformationDesempenhoFatComercial2 {
      margin: -6.5rem 0 0 21rem !important;
    }

    #textoMetaMensalComercial2 {
      font-size: 18px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 2rem 0 0 -13.6rem;
    }

    #ChartPieComercial2 {
      width: 80px;
      height: 50px;
      font-size: 18px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -3rem 0 0 6rem !important;
    }

    #BarLineComercial2 {
      height: 430px !important;
      width: 720px !important;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0rem 0 0rem 5rem;
    }

    #iconInformationFatxMetaComercial2 {
      margin: 2rem 0 0 -1.7rem;
    }

    .containerBarrasLinhas {
      display: flex;
      flex-wrap: wrap;
    }

    .itemBarrasLinhasComercial2 {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    #textoMesAnteriorComercial2 {
      font-size: 18px;
      margin: 3.35rem 0 0 0.4rem;
    }

    #faturamentoAnteriorComercial2 {
      font-size: 19px;
      display: block ruby;
      margin: 2rem 0rem 0 -1rem;
    }

    #iconInformationFatMesAnteriorComercial2 {
      margin: -3.5rem 0 0 29rem !important;
    }

    #componenteVlrFatAnteriorComercial2 {
      margin: -46rem 0 0 30rem;
    }

    #faturamentoMesAnoAnteriorComercial2 {
      font-size: 19px;
      display: block ruby;
      margin: 5rem 0 0 5.5rem;
    }

    #iconInformationFatMesAnoAnteriorComercial2 {
      margin: -3.5rem 0 0 29rem !important;
    }

    #componenteVlrFatMesAnoAnteriorComercial2 {
      margin: -47rem 0 0 34.5rem !important;
    }

    #ChartPie2Comercial2 {
      width: 80px;
      height: 50px;
      font-size: 13px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 33rem 0 0 17rem;
    }

    #iconInformationDesempenhoMesAnteriorComercial2 {
      margin: 0rem 0 0 25.1rem !important;
    }

    #textoMesAnoAnteriorComercial2 {
      font-size: 16px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 5rem 0 0 -10rem !important;
    }

    #linhaChartPie2Comercial2 {
      margin: -1rem 0 0 1rem;
    }

    #componenteGraficoPie2Comercial2 {
      margin: -1rem 0 0 9rem;
    }

    #titulo4 {
      margin: auto !important;
    }

    #ChartPie3Comercial2 {
      width: 80px;
      height: 50px;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 34rem 0 0 4rem !important;
    }

    #iconInformationDesMesAnoAnteriorComercial2 {
      margin: -2rem 0 0 0rem !important;
    }

    #dividerBloco1Comercial2 {
      margin-top: -33rem;
    }

    #iniciobloco2Comercial2 {
      font-size: 14px;
      display: flex;
      align-items: center;
    }

    .textoDiasFaturametno {
      margin: 13rem 0 0 2rem;
    }

    #iconInformationDiasUteisComercial2 {
      margin: 0 0 0 3.5rem !important;
    }

    #componenteDiasFaturadosComercial2 {
      margin: 0rem 0 0 16rem;
    }

    #iconInformationComercial2 {
      margin: 0rem 0 0 3rem !important;
    }

    #valorMonetarioComercial2 {
      font-size: 8px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0rem 0 0rem 7rem;
    }

    #valorMonetarioGraficoComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 0rem 0;
    }

    #valorMonetarioDiarioGraficoComercial2 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 0rem 0;
    }

    .textoTendenciaFaturametno {
      margin: 20rem 0 0 2rem;
    }

    #iconInformationTendenciaComercial2 {
      margin: 0rem 0 0 3.5rem !important;
      display: block;
    }

    #componenteVlrTendenciaComercial2 {
      margin: -2rem 0 0 31rem !important;
    }

    #textoCarteiraPedidoComercial2 {
      margin: 7rem 0 0 2rem;
    }

    #iconInformationPedidosComercial2 {
      margin: 0rem 0 0 3.5rem !important;
    }

    #componenteCarteiraPedidosComercial2 {
      margin: 1rem 0 0 27rem;
    }

    #volumetriaTextoComercial2 {
      margin: -3rem 0 5rem 2rem;
    }

    #iconInformationVolumetriaComercial2 {
      margin: -3rem 0 0 2rem !important;
    }

    #componenteVolumeLeiteComercial2 {
      margin: 7rem 0 0 -2rem;
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #faturamentoComercial2 {
      margin: 0 0 0 -10rem;
    }

    #iconInformationFaturamentoComercial2 {
      margin: -7.5rem 0 0 38rem;
    }

    #componenteValorFatComercial2 {
      margin: 0 0 0 1rem;
    }

    #textoDevolucaoImpropriaComercial2 {
      margin: -1rem 0 0 -6rem;
    }

    #iconInformationDevolucaoComercial2 {
      margin: -2rem 0 0 0rem;
    }

    #ChartDevolucaoImpropriaComercial2 {
      margin: 0 0 -3rem 0rem;
    }

    #metaComercial2 {
      margin: 0rem 0 0 -14rem;
    }

    #iconInformationMetaComercial2 {
      margin: -2rem 0 0 42rem;
    }

    #componentevlrMetaComercial2 {
      margin: 0rem 0 0 6.9rem;
    }

    #textoMetaMensalComercial2 {
      margin: 0rem 0 0 -10rem;
    }

    #ChartPieComercial2 {
      margin: -2.7rem 0 -3rem -2rem !important;
    }

    #iconInformationDesempenhoFatComercial2 {
      margin: -6.5rem 0 0 28rem !important;
    }

    #BarLineComercial2 {
      margin: 0 0 0 3rem;
    }

    #iconInformationFatxMetaComercial2 {
      margin: -2rem 0 0 0rem !important;
    }

    #ChartPie2Comercial2 {
      margin: 0 0 0 10rem !important;
    }

    #textoMesAnteriorComercial2 {
      margin: -1rem 0 0 -8.4rem;
    }

    #iconInformationDesempenhoMesAnteriorComercial2 {
      margin: -2rem 0 0 0rem !important;
    }

    #componenteGraficoPie2Comercial2 {
      margin: -6rem 0 0 -16rem;
    }

    #componenteFatMesAnoAnteriorComercial2 {
      margin: -2rem 0 0 0rem !important;
    }

    #componenteVlrFatMesAnoAnteriorComercial2 {
      margin: -2.2rem 0 0 4.1rem;
    }

    #faturamentoAnteriorComercial2 {
      margin: 0.1rem 0 0 -13rem;
    }

    #iconInformationFatMesAnteriorComercial2 {
      margin: -3.6rem 0 0 23.5rem !important;
    }

    #componenteVlrFatAnteriorComercial2 {
      margin: -0.5rem 0 0 0;
    }

    #componenteDesMesAnoAnteriorComercial2 {
      margin: -3rem 0 0 0rem;
    }

    #iconInformationFatMesAnoAnteriorComercial2 {
      margin: -4.5rem 0 0 27.5rem !important;
    }

    #iconInformationDesMesAnoAnteriorComercial2 {
      margin: -2rem 0 0 0rem !important;
    }

    #textoMesAnoAnteriorComercial2 {
      font-size: 16px;
      margin: 0.5rem 0 0 -10rem;
    }

    #ChartPie3Comercial2 {
      margin: -3rem 0 0 -1rem !important;
    }

    #iconInformationComercial2 {
      margin: 0rem 0 0 0rem !important;
    }

    #iconInformationTendenciaComercial2 {
      margin: 0rem 0 0 0rem !important;
    }

    #iconInformationDiasUteisComercial2 {
      margin: 0rem 0 0 0rem !important;
    }

    #componenteDiasFaturadosComercial2 {
      margin: -1rem 0 0 -5rem;
    }

    #iconInformationPedidosComercial2 {
      margin: 0rem 0 0 2.5rem !important;
    }

    #iconInformationVolumetriaComercial2 {
      margin: -2rem 0 0 2.6rem !important;
    }

    #componenteCarteiraPedidosComercial2 {
      margin: -2rem 0 0 2rem;
    }

    #volumetriaTextoComercial2 {
      margin: -2rem 0 0 0;
    }

    #componenteVolumeLeiteComercial2 {
      margin: -4rem 0 0 -6rem;
    }

    #linhaChartPie2Comercial2 {
      margin: 0 0 0 27rem;
    }
  }

  @media screen
  and (min-width: 1601px) {
    #faturamentoComercial2 {
      margin: 0 0 0 -10rem;
    }

    #iconInformationFaturamentoComercial2 {
      margin: -9.5rem 0 0 38rem;
    }

    #componenteValorFatComercial2 {
      margin: 1rem 0 0 0rem;
    }

    #textoDevolucaoImpropriaComercial2 {
      margin: -1rem 0 0 -6rem;
    }

    #iconInformationDevolucaoComercial2 {
      margin: 0rem 0 0 11.7rem;
    }

    #ChartDevolucaoImpropriaComercial2 {
      margin: 0 0 0 13rem;
    }

    #metaComercial2 {
      margin: 0rem 0 0 -14rem;
    }

    #iconInformationMetaComercial2 {
      margin: -2rem 0 0 42rem;
    }

    #componentevlrMetaComercial2 {
      margin: 0rem 0 0 2.9rem;
    }

    #textoMetaMensalComercial2 {
      margin: 0rem 0 0 -10rem;
    }

    #ChartPieComercial2 {
      margin: -3rem 0 -2rem 4rem !important;
    }

    #iconInformationDesempenhoFatComercial2 {
      margin: -6.5rem 0 0 28rem !important;
    }

    #iconInformationFatxMetaComercial2 {
      margin: -2rem 0 0 3rem !important;
    }

    #ChartPie2Comercial2 {
      margin: 0 0 0 10rem !important;
    }

    #textoMesAnteriorComercial2 {
      margin: -1rem 0 0 -5.4rem;
    }

    #iconInformationDesempenhoMesAnteriorComercial2 {
      margin: -3rem 0 0 0rem !important;
    }

    #linhaChartPie2Comercial2 {
      margin: 0 0 0 -8rem;
    }

    #componenteGraficoPie2Comercial2 {
      margin: 0rem 0 0 11rem;
    }

    #componenteFatMesAnoAnteriorComercial2 {
      margin: -3rem 0 0 0rem !important;
    }

    #componenteVlrFatMesAnoAnteriorComercial2 {
      margin: -2rem 0 0 3.1rem;
    }

    #faturamentoAnteriorComercial2 {
      margin: 0.1rem 0 0 -13rem;
    }

    #iconInformationFatMesAnteriorComercial2 {
      margin: -3.6rem 0 0 27rem !important;
    }

    #componenteVlrFatAnteriorComercial2 {
      margin: -0.5rem 0 0 0;
    }

    #componenteDesMesAnoAnteriorComercial2 {
      margin: -3rem 0 0 0;
    }

    #iconInformationFatMesAnoAnteriorComercial2 {
      margin: -4.6rem 0 0 30.2rem !important;
    }

    #iconInformationDesMesAnoAnteriorComercial2 {
      margin: -2rem 0 0 0rem !important;
    }

    #textoMesAnoAnteriorComercial2 {
      font-size: 16px;
      margin: -0.5rem 0 0 -10rem;
    }

    #ChartPie3Comercial2 {
      margin: 0rem 0 0 4rem !important;
    }

    #iconInformationComercial2 {
      margin: -0rem 0 0 0rem !important;
    }

    #iconInformationTendenciaComercial2 {
      margin: 0rem 0 0 0rem !important;
    }

    .textoDiasFaturametno {
      margin: auto
    }

    #iconInformationDiasUteisComercial2 {
      margin: 0rem 0 0 0.6rem !important;
    }

    #iconInformationPedidosComercial2 {
      margin: 0rem 0 0 1.2rem !important;
    }

    #iconInformationVolumetriaComercial2 {
      margin: -1rem 0 0 1.2rem !important;
    }
  }
</style>

<style lang="sass">
  .filterMobile
    display: none

  .filterWeb
    display: block

  #faturamentoComercial2
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 -4rem
    font-weight: bold

  #iconInformationFaturamentoComercial2
    margin: -7.5rem 0 0 20rem

  #textoDevolucaoImpropriaComercial2
    font-size: 16px
    display: grid
    align-items: center
    margin: -2rem auto
    font-weight: bold

  #iconInformationDevolucaoComercial2
    // margin: -1.9rem 0 0 16rem

  #metaComercial2
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 -8rem
    font-weight: bold

  #iconInformationMetaComercial2
    margin: -1.5rem 0 0 24rem

  #componentevlrMetaComercial2
    margin: 0 0 0 3rem

  #textoMetaMensalComercial2
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: 0 0 -2rem -4rem

  #ChartPieComercial2
    width: 120px
    height: 120px
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -2.3rem 0 -1rem 7rem !important

  #iconInformationDesempenhoFatComercial2
    margin: -2.5rem 0 0 16rem !important

  #iconInformationFatxMetaComercial2
    margin: -4.5rem 0 0 2rem

  #textoMesAnteriorComercial2
    font-size: 16px
    margin: 0 0 0 -2rem

  #linhaChartPie2Comercial2
    margin: 0 0 0 0rem

  #componenteGraficoPie2Comercial2
    margin: 0rem 0 1.3rem 9.5rem

  #faturamentoAnteriorComercial2
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 -7rem
    font-weight: bold

  #iconInformationFatMesAnteriorComercial2
    margin: -2.7rem 0 0 18rem !important

  #componenteVlrFatAnteriorComercial2
    margin: -1.5rem 0 0 0

  #textoMesAnoAnteriorComercial2
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin: -2rem 0 0 -6rem

  #faturamentoMesAnoAnteriorComercial2
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 -1rem
    font-weight: bold

  #iconInformationFatMesAnoAnteriorComercial2
    margin: -3.5rem 0 0 18rem !important

  #componenteVlrFatMesAnoAnteriorComercial2
    margin: -2rem 0 0 0

  #ChartPie2Comercial2
    width: 110px
    height: 80px
    font-size: 12px
    display: grid
    align-items: center
    font-weight: bold
    margin: -1.3rem 0 0 4.9rem !important

  #iconInformationDesempenhoMesAnteriorComercial2
    margin: -3rem 0 0 0rem !important

  #ChartPie3Comercial2
    width: 110px
    height: 80px
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: 0rem 0 0 4rem !important

  #iconInformationDesMesAnoAnteriorComercial2
    margin: -2rem 0 0 0rem !important

  #btnRefazer
    margin: 1.5rem auto

  #iconInformationComercial2
    margin: 0 0 0 0rem !important
    display: block

  #iconInformationTendenciaComercial2
    margin: 0rem 0 0 0rem !important
    display: block

  #componenteVlrTendenciaComercial2
    margin: -3rem 0 0 0rem

  #iconInformationPedidosComercial2
    margin: 0 0 0 1rem !important
    display: block

  #componenteCarteiraPedidosComercial2
    margin: -3rem 0 0 0

  #iconInformationVolumetriaComercial2
    margin: -1rem 0 0 1rem !important
    display: block

  #iniciobloco2Comercial2
    margin-left: 2rem

  #textoCarteiraPedidoComercial2
    margin-right: 5rem

  #volumetriaTextoComercial2
    margin: -1rem 0 0 0

  #componenteVolumeLeiteComercial2
    margin: -2rem 0 0 -4rem

  .textoDiasFaturametno
    margin: -1rem 0 0 0rem

  #iconInformationDiasUteisComercial2
    margin: 0 0 0 0rem !important

  #ChartDevolucaoImpropriaComercial2
    margin: 0 0 0 2rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemDevolucaoImpropria
    // padding-right: 4rem !important
    margin: -2rem 0 0 -1rem

  #componenteDevolucaoImpropria
    margin: 0rem 0 0 -1rem

  #componenteDevImpropria
    margin: -3rem 0 0 0

  #componenteMetaAtual
    margin: -0.7rem 0 0 0

  #componentenMetaMensal
    margin: -2rem 0 0 0

  #listItemFatxMetComercial2
    // padding-right: 44rem !important
    margin: -2rem 0 0 -1rem

  #listItemMesAnteriorComercial2
    // padding-right: 13rem !important
    margin: -2rem 0 0 -1rem

  #listItemValorMonetario
    // padding-right: 20rem !important
    margin: -2rem 0 0 -1rem

  #componenteValorMonetarioComercial2
    margin: -2rem 0 0 0

  #componenteTendenciaFaturamento
    margin: -2rem 0 0 0

  #componenteFatMesAnoAnteriorComercial2
    margin: -3rem 0 0 0rem !important

  #componenteDesMesAnoAnteriorComercial2
    margin: -3rem 0 0 0

</style>
